import React from 'react';

import { Box, Stack, Typography } from '@mui/material';

import PrimaryBtn from 'components/shared/Buttons/PrimaryButton';
import { useTranslation } from 'react-i18next';

interface ContractingButtonProps {
    taxNumber: string;
}

const ContractingButton: React.FC<ContractingButtonProps> = (props) => {
    const { taxNumber } = props;

    const { t } = useTranslation('profile', {
        keyPrefix: 'PROFILE.CONTRACTING',
    });

    return (
        <Stack height="100%" gap={1} justifyContent="space-between">
            <Stack>
                <Typography variant="h2">{t('TITLE')}</Typography>

                <Typography variant="body1" textAlign="justify">
                    {t('DESCRIPTION')}
                </Typography>
            </Stack>

            <Box>
                <PrimaryBtn
                    onClick={() =>
                        window.open(
                            `https://szerzodes.szerelvenybolt.hu/szerzodes/mester/index?taxNo=${taxNumber?.slice(
                                0,
                                8
                            )}`,
                            '_blank'
                        )
                    }
                >
                    {t('BUTTON')}
                </PrimaryBtn>
            </Box>
        </Stack>
    );
};

export default ContractingButton;
